import {
  SAVEDCARD,
  CLEARSAVEDCARD,
  ADYENCONFIG,
  ADYENCONFIG_ERROR,
  SAVE_ADYEN_SESSION
} from 'Constants'
import {
  RAZORPAY_SESSION,
  KENKO_PAYMENTS_SESSION,
  CLEAR_KENKO_PAYMENTS_SESSION,
  ADYEN_CONFIG_STATUS_ERROR
} from '../constants'

const initialState = {
  saveCardSubmitStatus: null,
  adyenConfig: null,
  adyenSession: null,
  razorpaySessionData: null,
  kenkoPaymentsSession: null
}

export default function(state = initialState, action) {
  switch (action.type) {
    case ADYENCONFIG:
      return { ...state, adyenConfig: action.payload }
    case SAVE_ADYEN_SESSION:
      return { ...state, adyenSession: action.payload }
    case ADYENCONFIG_ERROR:
      return {
        ...state,
        adyenConfig: {
          status: ADYEN_CONFIG_STATUS_ERROR,
          error: action.payload
        }
      }
    case RAZORPAY_SESSION:
      return { ...state, razorpaySessionData: action.payload }
    case KENKO_PAYMENTS_SESSION:
      return { ...state, kenkoPaymentsSession: action.payload }
    case CLEAR_KENKO_PAYMENTS_SESSION:
      return { ...state, kenkoPaymentsSession: null }
    case SAVEDCARD:
      return { ...state, saveCardSubmitStatus: action.payload }
    case CLEARSAVEDCARD: {
      return { ...state, saveCardSubmitStatus: null }
    }
    default:
      return state
  }
}
